<div class="container">
  <div class="row">
    <div class="staticPages" [class.sale]="language == 'bg'">
      <div id="for-investors">
        <h1>Investment Opportunity with Zavedenia.bg</h1>

        <p>
          <b>Introducing Zavedenia.bg</b><br />
          Since its establishment in 2007, Zavedenia.bg has become a cornerstone
          of the Bulgarian restaurant and food delivery market. With nearly two
          decades of experience, we have built a robust platform that caters to
          the needs of both restaurateurs and consumers. As we look towards the
          future, Zavedenia.bg is uniquely positioned to disrupt the food
          delivery marketplace in Bulgaria, leveraging our proven technology
          stack and our strategic partnerships to drive growth and create value.
        </p>

        <p>
          <b>Our Strategic Holdings</b><br />
          At Zavedenia.bg, we believe in Bitcoin as the future of money. This is
          why we have adopted a Bitcoin treasury policy, holding Bitcoin on our
          balance sheet as a strategic asset. Our commitment to this
          forward-thinking financial strategy not only secures our financial
          stability but also aligns us with the global shift towards a Bitcoin
          standard and a flag bearer for the Bitcoin circular economy in
          Bulgaria.
        </p>

        <p>
          <b>Order.bg: Our Leading Food Delivery Brand</b><br />
          We are proud to own and operate, as part of Zavedenia.bg, Order.bg,
          our food delivery brand in Bulgaria since 2020. Recently, Order.bg was
          featured by the Bitcoin Beach Circular Economy initiative,
          highlighting our innovative approach and commitment to integrating
          Bitcoin into our operations.<!-- You can watch the feature presentation here.-->
        </p>

        <p>
          Order.bg stands out in the competitive food delivery market with its
          user-friendly platform, extensive restaurant network, and excellent
          customer service. Our partnership with Bitcoin Beach further
          underscores our dedication to cutting-edge financial solutions and
          sustainable business practices.
        </p>

        <p>
          <b>Why Invest in Zavedenia.bg?</b><br />
          <b>Proven Track Record: </b>With over 15 years of experience,
          Zavedenia.bg has a proven track record of success and innovation in
          the food delivery industry.<br /><br />

          <b>Strategic Vision:</b> Our Bitcoin treasury policy and integration
          with Bitcoin Beach demonstrate our commitment to future-proofing our
          business and embracing new economic paradigms.<br /><br />

          <b>Growth Potential:</b> As the food delivery market continues to
          expand, Zavedenia.bg is poised to capitalise on new opportunities,
          driving growth and delivering exceptional value to our
          stakeholders.<br /><br />

          <b>Market Leadership:</b> Order.bg’s niche market presence and
          innovative approach position us as pioneers in the ethical food
          delivery in the Bulgarian food delivery space. We are now ready for
          faster expansion.<br /><br />

          We invite accredited investors to join us on this exciting journey as
          we continue to disrupt and redefine the food delivery marketplace in
          Bulgaria. Together, we can create a future where technology and
          tradition harmoniously coexist, driving sustained growth and
          prosperity.
        </p>

        <p>
          For more information on way you may get involved with Zavedenia and
          investment in this business opportunity, please contact Atanas Tonchev
          nakata&#64;zavedenia.com or +359887442693
        </p>
      </div>
      <div *ngIf="language == 'er'">
        <h1>Възможност за инвестиция със Zavedenia.bg</h1>
        <p>
          <b>Представяне на Zavedenia.bg</b><br />
          От създаването си през 2007 г., Zavedenia.bg се превърна в крайъгълен
          камък на българския ресторантьорски и доставен на храна пазар. С почти
          две десетилетия опит, ние сме изградили здрава платформа, която
          отговаря на нуждите както на ресторантьорите, така и на потребителите.
          Като гледаме към бъдещето, Zavedenia.bg е уникално позиционирана да
          наруши пазара за доставка на храна в България, използвайки доказаната
          си технологична платформа и стратегическите си партньорства, за да
          задвижим растежа и създадем стойност.
        </p>
        <p>
          <b>Нашите стратегически холдинги</b><br />
          В Zavedenia.bg вярваме, че Bitcoin е бъдещето на парите. Затова сме
          приели политика на държане на Bitcoin в нашия баланс като
          стратегически актив. Нашият ангажимент към тази напредничава финансова
          стратегия не само осигурява финансовата ни стабилност, но също така ни
          поставя в съответствие със световния преход към Bitcoin стандарт и
          водеща роля в Bitcoin циркулярната икономика в България.
        </p>
        <p>
          <b>Order.bg: Нашата водеща марка за доставка на храна</b><br />
          Горди сме да притежаваме и управляваме, като част от Zavedenia.bg,
          Order.bg, нашата марка за доставка на храна в България от 2020 г.
          Наскоро, Order.bg бе представена от инициативата Bitcoin Beach
          Circular Economy, подчертавайки нашия иновативен подход и ангажимент
          за интегриране на Bitcoin в нашите операции.
        </p>
        <p>
          Order.bg се откроява на конкурентния пазар за доставка на храна със
          своята удобна платформа, обширна мрежа от ресторанти и отлично
          обслужване на клиентите. Нашето партньорство с Bitcoin Beach
          допълнително подчертава нашата ангажираност към авангардни финансови
          решения и устойчиви бизнес практики.
        </p>
        <p>
          <b>Защо да инвестирате в Zavedenia.bg?</b><br />
          <b>Доказан опит: </b>С над 15 години опит, Zavedenia.bg има доказан
          опит в успех и иновации в индустрията за доставка на храна.<br /><br />
          <b>Стратегическа визия:</b> Нашата политика на Bitcoin съкровищница и
          интеграцията с Bitcoin Beach демонстрират нашата ангажираност към
          бъдещето на бизнеса и приемането на нови икономически парадигми.<br /><br />

          <b>Потенциал за растеж:</b> С разширяването на пазара за доставка на
          храна, Zavedenia.bg е в позиция да се възползва от нови възможности,
          задвижвайки растежа и предоставяйки изключителна стойност за нашите
          заинтересовани страни.<br /><br />

          <b>Лидерство на пазара:</b> Нишовото присъствие на Order.bg и
          иновативният подход ни поставят като пионери в етичната доставка на
          храна в българското пространство за доставка на храна. Сега сме готови
          за по-бързо разширяване.<br /><br />

          Каним акредитирани инвеститори да се присъединят към нас в това
          вълнуващо пътуване, докато продължаваме да нарушаваме и преосмисляме
          пазара за доставка на храна в България. Заедно можем да създадем
          бъдеще, в което технологиите и традициите хармонично съжителстват,
          задвижвайки устойчив растеж и просперитет.
        </p>

        <p>
          За повече информация относно възможностите за участие със Zavedenia и
          инвестиции в тази бизнес възможност, моля, свържете се с Атанас Тончев
          на nakata&#64;zavedenia.com или +359887442693
        </p>
      </div>
    </div>
  </div>
</div>
